<div fxLayout="row" fxLayoutAlign="center center">
  <form [formGroup]="mfaAuthFormGroup" fxLayout="column" fxLayoutAlign="center center" class="mfaauth-form">
    <div class="mfaauth-wrapper" fxFill>
      <mat-card-title class="title">AUTHORIZE</mat-card-title>
      <div class="mfaauth-container" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="10px">
        <mat-form-field>
          <label class="mat-form-label">Security Code</label>
          <input matInput formControlName="securityPin"  (keyup.enter)="onSubmitClick()" autofocus/>
          <mat-error
            *ngIf="mfaAuthFormGroup.get('securityPin').errors && mfaAuthFormGroup.get('securityPin').errors.required">
            Required Field</mat-error>
          <mat-error
            *ngIf="mfaAuthFormGroup.get('securityPin').errors && !mfaAuthFormGroup.get('securityPin').errors.required">
            Should contain 6 digits
          </mat-error>
        </mat-form-field>
        <button mat-raised-button type="button" class="submit-code-btn mat-raised-button mat-button-base mat-accent"
          (click)="onSubmitClick()">Submit</button>
      </div>
    </div>
  </form>
</div>